import React from 'react';
import delpicklogo from "../assets/images/delpick.png";
import loader from "../assets/images/loader.gif";


const Loader = () => {
    return (
        <>
            <div className='loader'>
                <div className='loaderin'>
                    <img src={loader} alt='delpicklogo' className='loadlogo' />
                    <div className='mt-3 mt-sm-4'>
                        <img src={delpicklogo} alt='delpicklogo' className='loadlogotwo' />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Loader;